// extracted by mini-css-extract-plugin
module.exports = {"cls1":"contacts-SocialBlock-module--cls1--Z_kff","cls2":"contacts-SocialBlock-module--cls2--2a1Fk contacts-SocialBlock-module--cls1--Z_kff"};